import React, { useEffect, useState } from 'react'
import { TableView, useDebounce } from '../../../_metronic/layout/components/RhEALComponent'

const MRList: React.FC = () => {


  const [myLoading, setMyLoading] = useState<boolean>(false);
  const [MRListData, setMRListData] = useState<any[]>([])
  const [pageNumber, setPageNumber] = useState<number>(1)
  const [totalRecords, setTotalRecords] = useState<number>(0)
  const [searchResult, setSearchResult] = useState<string>("");
  const [filterData, setFilterData] = useState<string>("")
  const [exportDisabled, setExportDisabled] = useState(false)
  const [exportMrData, setExportMrData] = useState<any[]>([])

  const debounceVal = useDebounce(searchResult, 700);
  const limit = 8;

  useEffect(() => {
    getMRList()
  }, [filterData, pageNumber, debounceVal])

  useEffect(() => {
    getMRListExport();
  }, [])

  // ---------- it is use for table data of mr -------------

  const getMRList = () => {
    setMyLoading(true);

    const getMRObj = {
      method: "get_mr_list",
      page: pageNumber,
      limit: limit,
      zone_id: filterData,
      searchMrName: debounceVal,
    };
    fetch(`${process.env.REACT_APP_API_URL_MAIN}get_mr_list`, {
      method: "POST",
      headers: {},
      body: JSON.stringify(getMRObj),
    })
      .then((result) => {
        result.json().then((response) => {
          if (response.status === 1) {
            setMRListData(response?.data);
            setTotalRecords(response?.total_records)
            setMyLoading(false);
          } else {
            setMyLoading(false);
          }
        });
      })
      .catch(() => {
        setMyLoading(false);
      });

  };

  // ------------ it is use for get mr list export -------------
  const getMRListExport = () => {
    const getMRObj = {
      method: "get_mr_list",
    };
    fetch(`${process.env.REACT_APP_API_URL_MAIN}get_mr_list`, {
      method: "POST",
      headers: {},
      body: JSON.stringify(getMRObj),
    })
      .then((result) => {
        result.json().then((response) => {
          if (response.status === 1) {
            setExportMrData(response?.data);
            setExportDisabled(true);
          }
        });
      })
      .catch(() => {

      });

  };


  return (
    <>
      <div className='col-12'>
        <TableView totalRecords={totalRecords} exportMrData={exportMrData} exportDisabled={exportDisabled} data={MRListData} setSearchResult={setSearchResult} loading={myLoading} setPageNumber={setPageNumber} pageNumber={pageNumber} limit={limit} setFilterData={setFilterData} filterData={filterData} searchData={debounceVal} tableHeading={'MR LIst'} th1={'Name'} th2={'Zone'} th3={'Submission Count'} />
      </div>
    </>
  )
}

export { MRList }
